import { IconsProps } from './IconsProps';

const Hamburger = ({
  className = '',
  viewBox = '0 0 36 36',
  width = 36,
  height = 36,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        d="M30 12H6V8H30V12ZM30 16H6V20H30V16ZM30 24H6V28H30V24Z"
        fill={svgFill}
      />
    </svg>
  );
};

export default Hamburger;
